import type { DomainGuide } from '@/components/guide/guide-types';

import { commonGuide } from './_common/index.js';
import { accountGuide } from './account/index.js';
import { affiliateGuide } from './affiliate/index.js';
import { auditGuide } from './audit/index.js';
import { authSessionsGuide } from './auth-sessions/index.js';
import { bettingGuide } from './betting/index.js';
import { bonusGuide } from './bonus/index.js';
import { contentGuide } from './content/index.js';
import { dashboardGuide } from './dashboard/index.js';
import { financeGuide } from './finance/index.js';
import { gamesGuide } from './games/index.js';
import { membersGuide } from './members/index.js';
import { notificationGuide } from './notification/index.js';
import { promotionGuide } from './promotion/index.js';
import { reconcileGuide } from './reconcile/index.js';
import { reportsGuide } from './reports/index.js';
import { riskGuide } from './risk/index.js';
import { rolesGuide } from './roles/index.js';
import { settingsGuide } from './settings/index.js';
import { settlementsGuide } from './settlements/index.js';
import { ticketsGuide } from './tickets/index.js';
import { siteGuide } from './site/index.js';
import { tenancyGuide } from './tenancy/index.js';
import { usersGuide } from './users/index.js';
import { walletGuide } from './wallet/index.js';

/**
 * Every domain's help catalog.
 *
 * This file is the ONLY shared file in the help system: each domain owns
 * `config/guide/<domain>/` entirely (structure + seven language files), so
 * domains can be written independently without touching each other. Adding a
 * domain is one import and one array entry here.
 */
export const GUIDE_REGISTRY: readonly DomainGuide[] = [
  commonGuide,
  accountGuide,
  affiliateGuide,
  auditGuide,
  authSessionsGuide,
  bettingGuide,
  bonusGuide,
  contentGuide,
  dashboardGuide,
  financeGuide,
  gamesGuide,
  membersGuide,
  notificationGuide,
  promotionGuide,
  reconcileGuide,
  reportsGuide,
  riskGuide,
  rolesGuide,
  settingsGuide,
  settlementsGuide,
  siteGuide,
  ticketsGuide,
  tenancyGuide,
  usersGuide,
  walletGuide,
];

/** Flat page lookup, keyed by `<domain>.<page>`. */
export const GUIDE_PAGES = new Map(
  GUIDE_REGISTRY.flatMap((d) => d.pages.map((p) => [p.id, p] as const)),
);

export function guidePage(pageId: string) {
  return GUIDE_PAGES.get(pageId);
}
